import axios from "axios"
axios.defaults.retry = 3; //重试次数
 axios.defaults.retryDelay = 2;//重试延时 单位秒
axios.defaults.timeout = 10000;//请求超时时间设置
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.headers['ua-limi'] = 'livevideo-student';
axios.defaults.transformRequest = [function (data) {//重写请求数据格式
    if(typeof(data) != 'object' || Object.prototype.toString.call(data) === '[object FormData]'|| Object.prototype.toString.call(data) === '[object ArrayBuffer]'){
        return data
    }
    let ret = ''
    for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
}];
axios.defaults.shouldRetry = (error) => {//重试条件，默认只要是错误都需要重试
    let config = error.config;
    if (config.needRepeat) {
        return true
    } else {
        return false
    }
};
// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error.response);
    });

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    err => {
        let config = err.config;
        // 判断是否配置了重试
        if (!config || !config.retry) return Promise.reject(err);

        if (!config.shouldRetry || typeof config.shouldRetry != 'function') {
            return Promise.reject(err);
        }

        //判断是否满足重试条件
        if (!config.shouldRetry(err)) {
            return Promise.reject(err);
        }

        // 设置重置次数，默认为0
        config.__retryCount = config.__retryCount || 0;

        // 判断是否超过了重试次数
        if (config.__retryCount >= config.retry) {
            return Promise.reject(err);
        }

        let retryDelay = config.retryDelay;
        //延迟重试时间计算
        if(config.needRepeat===2){
            let session_retryDelay = JSON.parse(sessionStorage.getItem('api_retry_wait')) || retryDelay;
            retryDelay = (session_retryDelay*config.__retryCount*2) || session_retryDelay; //n 2n 4n的运算
        }

        //重试次数自增
        config.__retryCount += 1;

        //延时处理
        var backoff = new Promise(function (resolve) {
            setTimeout(function () {
                resolve();
            }, retryDelay *1000 || 1000);
        });

        //重新发起axios请求
        return backoff.then(function () {
            return axios(config);
        });
    });
export default axios;



// WEBPACK FOOTER //
// ./src/js/axios.js